export default __webpack_public_path__ + "static/media/berny-artworkinfo4.f3e61e13.png";